import { ApprovedUsers } from "./approved-users";
import { useState, useEffect } from "react";
import { IconButton } from "@somethings-ui/web";
import { XIcon } from "lucide-react";

interface RightPanelProps {
  menteeName?: string; // Making it optional since "Jordan" was hardcoded before
  isVisible: boolean;
  toggleShowRightPanel: () => void;
  accessRecords: any[];
  mentorshipId: string;
  summary: string;
}

export function MentorUpdatesRightPanel({
  menteeName = "your mentee",
  isVisible,
  toggleShowRightPanel,
  accessRecords,
  summary,
}: RightPanelProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    if (!summary) {
      setIsLoading(true);
      setLoadFailed(false);

      const timer = setTimeout(() => {
        setIsLoading(false);
        setLoadFailed(true);
      }, 30000);

      return () => clearTimeout(timer);
    } else {
      setIsLoading(false); // Reset loading state when summary is available
      setLoadFailed(false); // Reset error state when summary is available
    }
  }, [summary]);

  if (!isVisible) {
    return (
      <button
        onClick={toggleShowRightPanel}
        className="fixed right-0 top-4 z-50 rounded-l-lg bg-white px-4 py-2 shadow-lg hover:bg-gray-50"
      >
        <span className="font-medium">Open AI Summary</span>
      </button>
    );
  }

  return (
    <div className="w-[600px] overflow-y-auto border-l border-gray-200">
      <div className="p-4">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="text-xl font-bold">Record Monthly Video</h1>
          <IconButton
            icon={<XIcon />}
            variant="ghost-black"
            size="md"
            onClick={toggleShowRightPanel}
          />
        </div>

        <div className="mb-6 border-l-4 border-orange-500 bg-orange-50 p-4">
          <p className="text-orange-700">
            Reminder to keep anything confidential that your teen wouldn&apos;t
            want you to share with their parents
          </p>
        </div>

        <div className="mb-6 rounded-lg bg-white p-6 shadow">
          <div className="mb-4 flex items-start justify-between gap-2">
            <div className="flex items-start gap-2">
              <span className="text-orange-500">★</span>
              <h2 className="font-bold">AI Monthly Summary</h2>
            </div>
          </div>

          <p className="mb-4 text-gray-600">
            This month, you and {menteeName} talked about the following topics:
          </p>

          <div className="space-y-4">
            {isLoading ? (
              <div className="flex items-center gap-2 text-gray-600">
                <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600"></div>
                <p>Loading summary...</p>
              </div>
            ) : summary ? (
              <div dangerouslySetInnerHTML={{ __html: summary }} />
            ) : loadFailed ? (
              <p className="text-red-600">
                Unable to create summary. Please try again.
              </p>
            ) : null}
          </div>
        </div>

        <ApprovedUsers accessRecords={accessRecords} />
      </div>
    </div>
  );
}
